module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Dashboard"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Custom",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', {
    ref: "container",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('splitpanes', {
    staticClass: "default-theme",
    staticStyle: {
      "height": "750px"
    }
  }, [_c('pane', {
    attrs: {
      "size": "20",
      "min-size": "10",
      "max-size": "50"
    }
  }), _vm._v(" "), _c('pane', [_vm._l((_vm.chartConfigs), function(chartConfig) {
    return [_c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('b-card', {
      attrs: {
        "title": chartConfig.name,
        "visible": true
      }
    }, [_c('b-card-text', {
      staticStyle: {
        "overflow": "auto",
        "height": "700px"
      }
    }, [_c('cpu-chart', {
      attrs: {
        "config": chartConfig
      }
    })], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-530270a8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/CustomDashboardPage.vue
// module id = 2144
// module chunks = 1